module.exports = __webpack_public_path__ + "static/process-detail-a.892c7047.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-a.png
// module id = 1495
// module chunks = 214286880276331